import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { toast } from "sonner";
import Sparkles from "./Sparkles";

const CtaBand = () => {
  return (
    <section className="relative z-10 overflow-hidden bg-[#0B0F19] py-8" data-testid="cta-band">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-3xl border border-[#F3E5AB]/15 bg-gradient-to-br from-[#141b2e] to-[#0d1220] px-8 py-16 text-center md:px-16 md:py-20"
        >
          <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-[600px] -translate-x-1/2 bloom-gold opacity-50" />
          <Sparkles count={18} />
          <div className="relative">
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Bulk & bespoke orders</span>
            <h2 className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-[#F3EEE3] md:text-6xl">
              Ready to gift this Diwali?
            </h2>
            <p className="mx-auto mt-5 max-w-xl font-sans text-base leading-relaxed text-[#A9B0C2]">
              Tell us your headcount and budget — we’ll craft a custom-branded proposal
              and deliver it across India in 2 days.
            </p>
            <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button
                onClick={() => toast.success("Thanks! Our gifting team will reach out shortly.")}
                data-testid="enquire-now-btn"
                className="btn-gold inline-flex items-center gap-2 rounded-full px-9 py-4 font-sans text-sm font-semibold tracking-wide"
              >
                Enquire Now <ArrowRight className="h-4 w-4" strokeWidth={2.2} />
              </button>
              <a
                href="https://api.whatsapp.com/send?phone=919650023803&text=Hi,%20I'm%20interested%20in%20Diwali%20corporate%20gifting"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-call-btn"
                className="inline-flex items-center gap-2 rounded-full border border-[#F3E5AB]/20 px-9 py-4 font-sans text-sm font-medium tracking-wide text-[#F3EEE3] transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
              >
                <Phone className="h-4 w-4" strokeWidth={1.8} /> Talk to Us
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaBand;
